module.exports = __webpack_public_path__ + "media/images/award-badges-th-098d833aacfde6c69c8af2036c191c79.svg";